<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-lg-5">
            <div class="col-8 blue_box p-4 text-center">
                <h3 class="heading">Verify your mobile number</h3>
            </div>
        </div>
        <div class="row m-0 justify-content-center">
            <form class="container-fluid page mt-60" ngForm #form="ngForm" (ngSubmit)="submit()" autocomplete="off">
                <div class="col-12 white_box p-4">
                    <p>Enter the OTP sent on your mobile
                        <strong>{{submitOtp.mobileNo}}</strong>
                    </p>
                    <div class="row justify-content-center">
                        <div class="form-group">
                            <ng-otp-input [config]="otpInputConfig" name="mobileOTP" [(ngModel)]="submitOtp.mobileOTP"
                                required #mobileOTP="ngModel"></ng-otp-input>
                            <div *ngIf="mobileOTP.invalid && (mobileOTP.dirty || mobileOTP.touched)" class="error">
                                <div *ngIf="mobileOTP.errors.required">
                                    <i class="fas fa-times-circle"></i> OTP is required.
                                </div>
                                <div *ngIf="mobileOTP.errors.pattern">
                                    <i class="fas fa-times-circle"></i> OTP must be numeric.
                                </div>
                                <div *ngIf="mobileOTP.errors.maxlength">
                                    <i class="fas fa-times-circle"></i> OTP must be 4 digits.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <div class="boxes">
                                <input type="checkbox" id="box1" class="form-check-input"
                                    [(ngModel)]="submitOtp.iConfirm" name="checkbox" #iConfirm="ngModel" required>
                                <label for="box1" tabindex="0" (keydown)="handleLabelKeydown($event)">Yes, I hereby
                                    appoint
                                    iTraveleo Private Limited ("Mihuru")<label *ngIf="!isExpanded" id="dots">...</label>
                                    <span class="label1" *ngIf="isExpanded" id="more"> as an authorized representative
                                        to receive my
                                        Credit information from Experian Credit Information Company of India Pvt. Ltd
                                        ("Experian") for the purpose of Credit Assessment for this application and also
                                        retrieve my KYC information from the Central KYC records for the same.
                                        Notwithstanding
                                        the above, to the extent permitted under the law, I agree and acknowledge that a
                                        lender
                                        identified by Mihuru can independently access my credit information in
                                        connection with
                                        its Own Credit Assessment. I declare that all the information provided here is
                                        correct.
                                        <br /><br />
                                        <span class="label1" *ngIf="isExpandedTandC" id="more">
                                            This End User Agreement (the "Agreement") is made between you (the "User" or
                                            "You") and iTraveleo Private Limited (Mihuru), a private limited company
                                            having its registered office at 58th Floor, 5805, Two ICC, Island City
                                            Center GD Ambekar Marg, Near Wadala Telephone Exchange Dadar (East), Mumbai
                                            - 400014 ("CLIENT", "Us" or "We", which term shall include its successors
                                            and permitted assigns). The User and CLIENT shall be collectively referred
                                            to as the "Parties"and individually as a "Party".<br /><br />
                                            BY EXECUTING THIS AGREEMENT / CONSENT FORM, YOU ARE EXPRESSLY AGREEING TO
                                            ACCESS THE EXPERIAN CREDIT INFORMATION REPORT AND CREDIT SCORE, AGGREGATE
                                            SCORES, INFERENCES, REFERENCES AND DETAILS (AS DEFINED BELOW) (TOGETHER
                                            REFERRED AS "CREDIT INFORMATION"). YOU HEREBY ALSO CONSENT TO SUCH CREDIT
                                            INFORMATION BEING PROVIDED BY EXPERIAN TO YOU AND CLIENT BY USING EXPERIAN
                                            TOOLS,ALGORITHMS AND DEVICES AND YOU HEREBY AGREE, ACKNOWLEDGE AND ACCEPT
                                            THE TERMS AND CONDITIONS SET FORTH HEREIN.<br /><br />
                                            <strong>Information Collection, Use, Confidentiality, No-Disclosure and Data
                                                Purging</strong>
                                            <br />CLIENT shall access your Credit Information as your authorized
                                            representative and CLIENT shall use the Credit Information for limited End
                                            Use Purpose consisting of and in relation to the services proposed to be
                                            availed by you from CLIENT. We shall not aggregate, retain, store, copy,
                                            reproduce, republish, upload, post, transmit, sell or rent the Credit
                                            Information to any other person and the same cannot be copied or reproduced
                                            other than as agreed herein and in furtherance to CICRA.
                                            The Parties agree to protect and keep confidential the Credit Information
                                            both online and offline.
                                            The Credit Information shared by you or received on by us on your behalf
                                            shall be destroyed, purged, erased promptly of upon the completion of the
                                            transaction/ End Use Purpose for which the Credit Information report was
                                            procured for up to a maximum of 6 months.
                                            <br /><br /><strong>Governing Law and Jurisdiction</strong>
                                            <br />The relationship between you and CLIENT shall be governed by laws of
                                            India and all claims or disputes arising there from shall be subject to the
                                            exclusive jurisdiction of the courts of Mumbai.
                                            <br /><br /><strong>Definitions:</strong>
                                            Capitalized terms used herein but not defined above shall have the following
                                            meanings:
                                            <br /><strong>"Business Day"</strong> means a day (other than a public
                                            holiday) on which banks are open for general business in Mumbai.
                                            <br /><strong>"Credit Information Report"</strong> means the credit
                                            information / scores/ aggregates / variables / inferences or reports which
                                            shall be generated by Experian;
                                            <br /><strong>"Credit Score"</strong> means the score which shall be
                                            mentioned on the Credit Information Report which shall be computed by
                                            Experian.
                                            <br /><strong>"CICRA"</strong> shall mean the Credit Information Companies
                                            (Regulation) Act, 2005 read with the Credit Information Companies Rules,
                                            2006 and the Credit Information Companies Regulations, 2006, and shall
                                            include any other rules and regulations prescribed thereunder.
                                            <br /><br /><strong>PLEASE READ THE ABOVEMENTIONED TERMS AND CONDITIONS AND
                                                CLICK ON "ACCEPT" FOLLOWED BY THE LINK BELOW TO COMPLETE THE
                                                AUTHORISATION PROCESS/ FOR SHARING OF YOUR CREDIT INFORMATION BY
                                                EXPERIAN WITH CLIENT IN ITS CAPACITY AS YOUR AUTHORISED REPRESENTATIVE.
                                                BY CLICKING "ACCEPT" YOU AGREE AND ACCEPT THE DISCLAIMERS AND TERMS AND
                                                CONDITIONS SET OUT HEREIN.</strong></span>
                                        <a class="adecor"
                                            (click)="toggleTandC(); $event.stopPropagation(); $event.preventDefault();">{{
                                            isExpandedTandC ? '(Experian T&C) |' : '(Experian T&C) | ' }}</a></span>
                                    <a class="adecor"
                                        (click)="toggleReadMore(); $event.stopPropagation(); $event.preventDefault();">{{
                                        isExpanded ? 'Read less' : 'Read more' }}</a></label>
                            </div>

                        </div>
                    </div>
                    <div class="row justify-content-center mt-2 text-center buttonDiv">
                        <div class="col-12">
                            <button type="submit" class="btn btn-warning mt-3"
                                [disabled]="(mobileOTP.invalid || !submitOtp.iConfirm)" tabindex="0"> Verify
                            </button>
                        </div>
                        <div class="timer-container">
                            <span *ngIf="!resendAvailable">Didn't you receive any code? {{ timeRemaining }}s</span>
                            <button *ngIf="resendAvailable" class="btn btn-link btn-response" (click)="resendOtp()"
                                tabindex="0">
                                <i class="fa fa-paper-plane" aria-hidden="true"
                                    style="color: #044b5f;font-size:1em;"></i>
                                <svg height="20" width="55" style="font-weight: unset;">
                                    <text x="5" y="13" fill="blue" font-size="1em" style="font-weight: 500;">Resend
                                        OTP</text>
                                </svg>
                            </button>
                        </div>
                        <p class="info m-0">We will do a soft credit check that will not impact your credit score</p>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="col-lg-5 col-12">
        <app-assist-left></app-assist-left>
    </div>
    <ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>
</div>

<ng-content *ngIf="isInCorrectPhoneNumber">
    <div id="overlay-credit-phone" class="overlay-credit-phone"></div>
    <div id="popup-credit-phone" class="popup-credit-phone">
        <div class="row justify-content-center mt-3 d-flex flex-sm-row-reverse">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row justify-content-center mt-lg-5">
                    <div class="col-9 col-sm-8 blue_box p-4 text-center">
                        <h3 class="heading">Confirm your details</h3>
                    </div>
                </div>
                <div class="row m-0 justify-content-center">
                    <div class="col-12 col-sm-11 white_box p-4">
                        <div class="container-fluid page mt-60">
                            <form *ngIf="showDialog">
                                <div class="error">{{isInCorrectPhoneNumberMessage}}</div>
                                <div class="row mt-4">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="mobileNo" class="control-label">Mobile Number</label>
                                            <input type="text" required class="form-control"
                                                placeholder="Enter Mobile Number" pattern="^[A-Z]{5}[0-9]{4}[A-Z]{1}$"
                                                maxlength="10" minlength="10"
                                                (change)="onChangeAlternativeInput($event)">
                                            <!-- <input type="text" formControlName="mobileNo" required class="form-control" placeholder="Enter Mobile Number" pattern="^[A-Z]{5}[0-9]{4}[A-Z]{1}$" maxlength="10" minlength="10">-->
                                            <div *ngIf="alternativeNumberErrorMsg" class="error">
                                                {{alternativeNumberErrorMsg}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center text-center buttonDiv">
                                    <div class="col-12">
                                        <button (click)="sendAlternativeOTP()" class="btn btn-warning mt-3"> Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <form *ngIf="!showDialog">
                                <div class="row mt-4">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="mobileOTP" class="control-label">Enter OTP</label>
                                            <input type="text" required class="form-control" placeholder="Enter OTP"
                                                maxlength="4" minlength="4" [(ngModel)]="alternativeNumberOTP"
                                                name="mobileOTP">
                                            <div *ngIf="" class="error">
                                                Enter Correct OTP
                                            </div>
                                            <div class="timer-container">
                                                <span *ngIf="!resendAvailable">{{ timeRemaining }}s</span>
                                                <button *ngIf="resendAvailable" class="btn btn-link btn-response"
                                                    (click)="resendOtp()">
                                                    <i class="fa fa-paper-plane" aria-hidden="true"
                                                        style="color: #044b5f;font-size:1em;"></i>
                                                    <svg height="20" width="55" style="font-weight: unset;">
                                                        <text x="5" y="13" fill="blue" font-size="1em"
                                                            style="font-weight: 500;">Resend</text>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center text-center buttonDiv">
                                    <div class="col-12">
                                        <button (click)="confirmNewNumber()" class="btn btn-warning mt-3"> Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-content>